/**
 * Material-style click ripple. Add `data-ripple` on any element to opt in —
 * or `.btn`, `.card` and `button` are auto-included via bindGlobalRipple().
 * Ink node is short-lived, cleaned up after the animation.
 */
export function bindGlobalRipple() {
  if (typeof document === "undefined") return;
  document.addEventListener("pointerdown", (e) => {
    const target = e.target as HTMLElement | null;
    if (!target) return;
    const el = target.closest("button, .btn, .card, [data-ripple]") as HTMLElement | null;
    if (!el || el.hasAttribute("data-no-ripple")) return;
    // Give it .ripple so it clips the ink to its own bounds.
    if (!el.classList.contains("ripple")) el.classList.add("ripple");
    const rect = el.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const ink = document.createElement("span");
    ink.className = "ripple-ink";
    ink.style.width = ink.style.height = `${size}px`;
    ink.style.left = `${e.clientX - rect.left - size / 2}px`;
    ink.style.top = `${e.clientY - rect.top - size / 2}px`;
    el.appendChild(ink);
    setTimeout(() => ink.remove(), 550);
  }, { passive: true });
}
